<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <rkm-area title="Dados da competência">
            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-select
                        :options="form.unidades"
                        :validations="validations.unidadeId"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :disabled="!model.unidadeId"
                        :options="form.competencias"
                        :validations="validations.competenciaId"
                        label="Mês"
                        show-default-option
                        text-field="mes"
                        v-model="model.competenciaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.competencias"
                        :validations="validations.competenciaId"
                        label="Ano"
                        show-default-option
                        text-field="ano"
                        v-model="model.competenciaId"
                        value-field="id"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :disabled="!model.competenciaId"
                        :repository="repositories.usuario"
                        :search-fields="fields.usuario"
                        :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                        :validations="validations.usuarioId"
                        label="Profissional"
                        v-model="model.usuario"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input-autocomplete
                        :disabled="!model.usuario"
                        :repository="repositories.ocupacao"
                        :request-query-string-params="{ usuario_id: model.usuario ? model.usuario.id : null }"
                        :search-fields="fields.ocupacao"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :validations="validations.ocupacaoId"
                        label="CBO"
                        placeholder="Digite o código ou nome do CBO"
                        v-model="model.ocupacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Dados do paciente">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="!model.ocupacao"
                        :repository="repositories.paciente"
                        :search-fields="fields.paciente"
                        :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                        :validations="validations.pacienteId"
                        label="Nome"
                        v-model="model.paciente"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-date-picker
                        :value="model.paciente ? model.paciente.cidadao.dataNascimento : null"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="model.paciente ? model.paciente.cidadao.sexo.descricao : null"
                        disabled
                        label="Sexo"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.cns ? formatCns(model.paciente.cidadao.cns) : null"
                        disabled
                        label="CNS"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="model.paciente ? model.paciente.cidadao.nacionalidade.descricao : null"
                        disabled
                        label="Nacionalidade"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="model.paciente ? model.paciente.cidadao.racaCor.descricao : null"
                        disabled
                        label="Raça/Cor"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.etniaIndigena ? model.paciente.cidadao.etniaIndigena.descricao : null"
                        disabled
                        label="Etnia indígena"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.domicilio && model.paciente.cidadao.domicilio.endereco.logradouro.cep ? formatCep(model.paciente.cidadao.domicilio.endereco.logradouro.cep) : null"
                        disabled
                        label="CEP"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.domicilio ? model.paciente.cidadao.domicilio.endereco.logradouro.municipio.nome : null"
                        disabled
                        label="Município de residência"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.domicilio ? model.paciente.cidadao.domicilio.endereco.logradouro.tipo.descricao : null"
                        disabled
                        label="Tipo de logradouro"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.domicilio ? model.paciente.cidadao.domicilio.endereco.logradouro.nome : null"
                        disabled
                        label="Logradouro"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Número"
                        :value="model.paciente && model.paciente.cidadao.domicilio ? model.paciente.cidadao.domicilio.endereco.numero : null"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="model.paciente && model.paciente.cidadao.domicilio ? model.paciente.cidadao.domicilio.endereco.complemento : null"
                        disabled
                        label="Complemento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Bairro"
                        :value="model.paciente && model.paciente.cidadao.domicilio ? model.paciente.cidadao.domicilio.endereco.logradouro.bairro.nome : null"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        disabled
                        label="Telefone"
                        :value="model.paciente ? model.paciente.cidadao.telefonePrincipal.numero : null"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="model.paciente ? model.paciente.email : null"
                        disabled
                        label="E-mail"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Dados do procedimento">
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-date-picker
                        :disabled="!model.paciente"
                        :max-date="additionals.dataFinal"
                        :min-date="additionals.dataInicial"
                        :validations="validations.dataAtendimento"
                        label="Data do atendimento"
                        v-model="model.dataAtendimento"
                    />
                </rkm-col>

                <rkm-col cols="8">
                    <rkm-form-input-autocomplete
                        :disabled="!model.paciente"
                        :repository="repositories.procedimento"
                        :request-query-string-params="{
                            competencia_id: model.competenciaId,
                            instrumento_registro: enums.registro.BPA_INDIVIDUALIZADO,
                            ocupacao_id: model.ocupacao ? model.ocupacao.id : null,
                            paciente_id: model.paciente ? model.paciente.id : null,
                            search_by_apelido: this.additionals.searchByApelido,
                        }"
                        :search-fields="fields.procedimento"
                        :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                        :validations="validations.procedimentoId"
                        label="Procedimento"
                        v-model="model.procedimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.procedimento"
                        :validations="validations.quantidade"
                        label="Quantidade"
                        type="number"
                        v-model="model.quantidade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="!model.procedimento"
                        :repository="repositories.servico"
                        :request-query-string-params="{ procedimento_id: model.procedimento ? model.procedimento.id : null }"
                        :search-fields="fields.servico"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        label="Serviço"
                        v-model="model.servico"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="!model.procedimento"
                        :repository="repositories.classificacao"
                        :request-query-string-params="{
                            procedimento_id: model.procedimento ? model.procedimento.id : null,
                            servico_id: model.servico ? model.servico.id : null,
                        }"
                        :search-fields="fields.classificacao"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :validations="validations.classificacaoId"
                        label="Classificação"
                        v-model="model.classificacao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-input-autocomplete
                        :disabled="!model.procedimento"
                        :repository="repositories.cid"
                        :request-query-string-params="{
                            procedimento_id: model.procedimento && model.procedimento.hasCidPrincipal == 1 ? model.procedimento.id : null,
                        }"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :validations="validations.cidId"
                        label="CID"
                        v-model="model.cid"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :disabled="!model.procedimento"
                        :options="form.carateresAtendimento"
                        :validations="validations.caraterAtendimentoId"
                        label="Caráter de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.caraterAtendimentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Enums.
import registro from '@/enums/sigtap/registro'

// Mixins.
import { error, formats, repository, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

import mesesAno from '@/enums/geral/mesesAno'

export default {
    computed: {
        fields() {
            return {
                usuario: [
                    { key: 'cadastroCidadao.nome', searchable: true },
                ],
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
                procedimento: this.additionals.searchByApelido
                    ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                    : [{ key: 'codigo', searchable: true }, { key: 'nome', searchable: true }],
                servico: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                classificacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                unidadeId: { required: true },
                competenciaId: { required: true },
                usuarioId: { required: true },
                ocupacaoId: { required: true },
                pacienteId: { required: true },
                dataAtendimento: { required: true },
                procedimentoId: { required: true },
                quantidade: {
                    required: true,
                    min_value: 1,
                    max_value: this.model.procedimento ? this.model.procedimento.quantidadeMaximaExecucao : null,
                },
                classificacaoId: { required: !!(this.model.servico && this.model.servico.id) },
                cidId: { required: this.model.procedimento && this.model.procedimento.hasCidPrincipal == 1 ? true : false },
                caraterAtendimentoId: { required: true, },
            }
        },
    },
    created() {
        this.repositories = {
            procedimentoIndividualizado: this.getConectaSusRepository('bpa.procedimentoIndividualizado'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            servico: this.getConectaSusRepository('sigtap.servico'),
            classificacao: this.getConectaSusRepository('sigtap.classificacao'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        additionals: {
            dataInicial: null,
            dataFinal: null,
            searchByApelido: false,
        },
        enums: {
            registro,
            mesesAno
        },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                const request = {
                    acao: 'lancamento',
                    origem: this.origem,
                }

                this.repositories.procedimentoIndividualizado.edit(this.id, this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.form.competencias = this.form.competencias.map(c => {
                            return {
                                id: c.id,
                                valor: c.valor,
                                mes: this.enums.mesesAno[parseInt(c.valor.slice(4))],
                                ano: c.valor.slice(0,4)
                            }
                        })
                        this.model = Object.assign(response.data.model)

                        this.model.paciente.cidadao.cns = response.data.model.paciente.cidadao.cns ? this.formatCns(response.data.model.paciente.cidadao.cns) : null

                        this.model.paciente.cidadao.domicilio.endereco.logradouro.cep = response.data.model.paciente.cidadao.domicilio.endereco.logradouro.cep
                            ? this.formatCep(response.data.model.paciente.cidadao.domicilio.endereco.logradouro.cep)
                            : null

                        this.model.paciente.cidadao.telefonePrincipal.numero = response.data.model.paciente.cidadao.telefonePrincipal.numero
                            ? this.formatPhoneOrCellPhone(response.data.model.paciente.cidadao.telefonePrincipal.numero)
                            : null

                        this.addWatchers()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                const request = { acao: 'lancamento' }

                this.repositories.procedimentoIndividualizado.create(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.form.competencias = this.form.competencias.map(c => {
                            return {
                                id: c.id,
                                valor: c.valor,
                                mes: this.enums.mesesAno[parseInt(c.valor.slice(4))],
                                ano: c.valor.slice(0,4)
                            }
                        })
                        this.model = Object.assign(response.data.model)

                        this.addWatchers()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleProcedimentoAutocompleted(item) {
            if (item) {
                this.model.procedimento.nome = item.nome
                this.model.procedimento.quantidadeMaximaExecucao = item.quantidadeMaximaExecucao
                this.model.procedimento.hasCidPrincipal = !!item.hasCidPrincipal
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        let request = {
                            acao: this.model.acao,
                            unidadeId: this.model.unidadeId,
                            competenciaId: this.model.competenciaId,
                            usuarioId: this.model.usuario.id,
                            ocupacaoId: this.model.ocupacao.id,
                            pacienteId: this.model.paciente.id,
                            dataAtendimento: moment(this.model.dataAtendimento).format('YYYY-MM-DD'),
                            procedimentoId: this.model.procedimento.id,
                            quantidade: this.model.quantidade,
                            servicoId: this.model.servico ? this.model.servico.id : null,
                            classificacaoId: this.model.classificacao ? this.model.classificacao.id : null,
                            cidId: this.model.cid ? this.model.cid.id : null,
                            caraterAtendimentoId: this.model.caraterAtendimentoId,
                        }

                        if (this.id) {
                            request.origem = this.origem

                            this.repositories.procedimentoIndividualizado.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {
                            this.repositories.procedimentoIndividualizado.store(this.camelObjectKeysToSnakeRecursive(request))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }
                    }
                })
        },
        addWatchers() {
            this.addWatcherUnidade()
            this.addWatcherCompetencia()
            this.addWatcherUsuario()
            this.addWatcherOcupacao()
            this.addWatcherPaciente()
            this.addWatcherProcedimento()
            this.addWatcherServico()
        },
        addWatcherUnidade() {
            this.$watch('model.unidadeId', function() {
                this.model.competenciaId = null
            })
        },
        addWatcherCompetencia() {
            this.$watch('model.competenciaId', function() {
                this.model.usuario = null
            })
        },
        addWatcherUsuario() {
            this.$watch('model.usuario', function() {
                this.model.ocupacao = null
            })
        },
        addWatcherOcupacao() {
            this.$watch('model.ocupacao', function() {
                this.model.paciente = null
            })
        },
        addWatcherPaciente() {
            this.$watch('model.paciente', function() {
                this.model.dataAtendimento = null
                this.model.procedimento = null
            })
        },
        addWatcherProcedimento() {
            this.$watch('model.procedimento', function() {
                this.model.quantidade = null
                this.model.servico = null
                this.model.classificacao = null
                this.model.cid = null
                this.model.caraterAtendimentoId = null
            })
        },
        addWatcherServico() {
            this.$watch('model.servico.id', function() {
                this.model.classificacao = null
            })
        },
    },
    mixins: [ error, formats, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
        origem: { type: String },
    },
    watch: {
        'model.competenciaId'(value) {
            if (value) {
                const competencia = this.form.competencias.find(competencia => competencia.id === value)

                if (competencia) {
                    const primeiroDia = moment(`${competencia.valor.substring(0, 4)}-${competencia.valor.substring(4, 6)}-01`).startOf('month').format('DD')
                    const ultimoDia = moment(`${competencia.valor.substring(0, 4)}-${competencia.valor.substring(4, 6)}-01`).endOf('month').format('DD')

                    this.additionals.dataInicial = `${primeiroDia}/${competencia.valor.substring(4, 6)}/${competencia.valor.substring(0, 4)}`
                    this.additionals.dataFinal = `${ultimoDia}/${competencia.valor.substring(4, 6)}/${competencia.valor.substring(0, 4)}`
                } else {
                    this.additionals.dataInicial = null
                    this.additionals.dataFinal = null
                }
            } else {
                this.additionals.dataInicial = null
                this.additionals.dataFinal = null
            }
        },
    },
}
</script>